import React from 'react';

import {Segment, Header, Radio} from 'semantic-ui-react';
import styles from '../App.module.scss';

function Question({index, title, options, value, onChange}) {

  const handleChange = (e, data) => {
    onChange(index, data.value);
  }

  return (
    <Segment basic className={styles.question}>
      <Header as='h2'>{title}</Header>
      {options.map(option => {
        return (
          <div key={option.value}>
            <Radio
              label={option.label}
              name={`questtion_${index}`}
              value={option.value}
              checked={option.value === value}
              onClick={handleChange}
            />
          </div>
        )
      })}
    </Segment>
  );
}

export default Question;
